<template>
    <AppModal :name="name" :beforeClose="beforeClose" :onEnterKeyPress="sendMessage">

        <template slot="header">
            Contact Sales
        </template>

        <template slot="content">
            <div class="text-left">
                <p class="text-bold mb-2">Your account manager</p>
                <p class="mb-1">Tim Quintal</p>
                <p class="mb-2">
                    Phone: <a href="tel:0404290119" target="_blank" class="pr-3">+61 7 3186 0311</a>
                    Email: <a
                        :href="isWebExpensesApp ? 'mailto:contact.apac@webexpenses.com' : 'mailto:tim.q@zudello.com'"
                        target="_blank">
                        {{ isWebExpensesApp ? 'contact.apac@webexpenses.com' : 'tim.q@zudello.com' }}
                    </a>
                </p>
            </div>

            <button @click="openCallMe" class="btn btn-outline-primary w-100">
                Request a callback
            </button>

            <p class="mt-3 text-muted font-18">Or send us a message</p>
            <hr>
            <textarea v-model.trim="message"
                      @input="vuelidateDelayTouch($v.message, touchMap)"
                      rows="4"
                      type="text"
                      class="form-control"
                      placeholder="Get in touch, we'd love to hear from you">
            </textarea>
            <small v-if="$v.message.$error" class="form-text text-danger text-left">
                <span v-if="!$v.message.required">This field is required</span>
            </small>
        </template>

        <template slot="actions">
            <button @click="sendMessage" v-loading.btn="isLoading" class="btn btn-primary w-100">
                Send Message
            </button>
            <div class="row justify-content-end">
                <button @click="$modal.hide(name)" class="btn btn-link mt-3">Close</button>
            </div>
        </template>

    </AppModal>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import contact from '../../../../command/contact'
import CallBackModal from '../../callBack.vue'

export default {
    name: 'ContactUsToUpdateBillingPlan',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            touchMap: new WeakMap(),

            message: '',
            isLoading: false
        }
    },
    validations: {
        message: {required}
    },
    methods: {
        beforeClose() {
            this.message = ''
            this.$v.$reset()
        },

        sendMessage() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }
            this.isLoading = true
            contact.support({body: this.message})
                .then(() => {
                    this.$snackbar.show({type: 'SUCCESS', text: 'Thank you, we will be in touch shortly.'})
                    this.$modal.hide(this.name)
                })
                .catch(() => {
                    this.$snackbar.show({
                        type: 'ERROR',
                        text: 'Sorry, we are currently unable to send your suggestion. We want to hear from you please try again or contact support.',
                        duration: 15000,
                        withClose: true
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        openCallMe() {
            this.$modal.hide(this.name)

            this.$modal.show(CallBackModal, {iframe: 'https://calendly.com/zudello'}, {
                width: '80%',
                height: 'auto'
            })
        }
    }
}
</script>

<style scoped>
    button {
        width: 120px;
    }
</style>
